//  Client\client-vite\src\App.tsx
import Router from "./router";

function App() {
  return <Router />;
}

export default App;
